import { useForm, useFieldArray } from "react-hook-form";
import { Box, Button, Card, CardContent, CardHeader, Chip, Divider, Grid, IconButton, InputAdornment, Paper, TextField, Tooltip, Typography } from "@mui/material";
import { apiConstants, post } from "../../common/constants";
import { useSnackbar } from "notistack";
import { FormProvider } from "../../common/hook-form";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { LoadingButton } from "@mui/lab";
import { useState } from "react";
import { useEffect } from "react";

function BankDetails(props) {
    const { rows, setReload, reload, setOpen, reportStage } = props;
    const { enqueueSnackbar } = useSnackbar();
    const [isSubmitting, setIsSubmitting] = useState(false)

    const methods = useForm({
        // resolver: yupResolver(Yup.array(Yup.object().shape({
        //     paymentMode: Yup.string().required("Please select the paymnet mode"),
        //     bankName: Yup.string().required("Please provide Bank Name"),
        //     timestamp: Yup.string().required("Please provide Date"),
        //     utrNo: Yup.string().required("Please provide UTR no"),
        //     amount: Yup.string().required("Please provide Amount"),
        // }))), 
        defaultValues: {
            remark: "",
            list: [
                {
                    paymentMode: "",
                    bankName: "",
                    utrNo: "",
                    timestamp: "",
                    amount: "",
                },
            ],
        },
    }

    );

    const { handleSubmit, control, register, reset, setValue, formState: { errors } } = methods;

    const { fields, append, remove } = useFieldArray({
        control,
        name: "list",
    });

    useEffect(() => {
        setValue(`remark`, rows?.remark)
        if (rows?.merchantPaymentDetails?.length > 0) {
            for (let i = 0; i < rows?.merchantPaymentDetails?.length; i++) {
                setValue(`list.${i}.paymentMode`, rows?.merchantPaymentDetails[i].paymentMode)
                setValue(`list.${i}.bankName`, rows?.merchantPaymentDetails[i].bankName)
                setValue(`list.${i}.utrNo`, rows?.merchantPaymentDetails[i].utrNo)
                setValue(`list.${i}.amount`, rows?.merchantPaymentDetails[i].amount)
                setValue(`list.${i}.timestamp`, rows?.merchantPaymentDetails[i].paymentDate ? rows?.merchantPaymentDetails[i].paymentDate.split(":00Z")[0] : "")
            }
        }
        else {
            setValue(`list.${0}.paymentMode`, "")
            setValue(`list.${0}.bankName`, "")
            setValue(`list.${0}.utrNo`, "")
            setValue(`list.${0}.amount`, "")
            setValue(`list.${0}.timestamp`, "")
            setValue(`remark`, "")
        }
    }, [])

    const onSubmit = async (data) => {
        if (reportStage === "PARTIALLY_PAID" && !data.remark?.trim()) {
            enqueueSnackbar("Remark is required for Partially Paid status", { variant: 'error' });
            return;
        }
        setIsSubmitting(true)
        const newDate = data.list?.map((item) => {
            item.paymentDate = item.timestamp + ":00Z";
            return item;
        })

        await post(apiConstants.COD_ACTION, {
            "reportId": rows?.id,
            "action": "ADD_PAYMENT",
            "remark": data.remark,
            "paymentDetailList": newDate
        }).then((res) => {
            if (res.data.status === "SUCCESS") {
                enqueueSnackbar(res.data.responseObj, { variant: 'success' })
                setReload(() => reload + 1)
                setOpen(() => false)
                reset()
            }
            else {
                enqueueSnackbar(res.data?.errorMsg, { variant: 'error' })
                // setReload(() => reload + 1)
                // reset()
            }

        }).catch((err) => console.log(err))
        setIsSubmitting(false)

    };


    return (
        <Card variant="outlined" sx={{ borderRadius: 2 }}>
            <CardHeader
                avatar={<AccountBalanceIcon color="primary" />}
                title="Bank Payment Details"
                titleTypographyProps={{ variant: "h6", fontWeight: 600 }}
                sx={{ px: 3, py: 2 }}
            />
            <Divider />
            <CardContent sx={{ px: 3, pt: 3, pb: 3 }}>
                <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={2}>

                        {fields.map((field, index) => (
                            <Grid item xs={12} key={field.id}>
                                <Paper
                                    variant="outlined"
                                    sx={{
                                        borderRadius: 2,
                                        borderLeft: '3px solid',
                                        borderLeftColor: 'primary.main',
                                        overflow: 'hidden',
                                    }}
                                >
                                    {/* Entry header */}
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            px: 2,
                                            py: 1.25,
                                            bgcolor: 'primary.50',
                                            borderBottom: '1px solid',
                                            borderColor: 'divider',
                                        }}
                                    >
                                        <Chip
                                            label={`Entry ${index + 1}`}
                                            size="small"
                                            color="primary"
                                            variant="outlined"
                                            sx={{ fontWeight: 600, fontSize: '0.7rem' }}
                                        />
                                        {fields.length !== 1 && (
                                            <Tooltip title="Remove this entry">
                                                <IconButton
                                                    size="small"
                                                    color="error"
                                                    onClick={() => remove(index)}
                                                >
                                                    <DeleteOutlineIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                    </Box>

                                    {/* Entry fields */}
                                    <Box sx={{ p: 2 }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    fullWidth
                                                    size="small"
                                                    label="Payment Mode"
                                                    {...register(`list.${index}.paymentMode`)}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    fullWidth
                                                    size="small"
                                                    label="Bank Name"
                                                    {...register(`list.${index}.bankName`)}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    fullWidth
                                                    size="small"
                                                    label="UTR No."
                                                    {...register(`list.${index}.utrNo`)}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    fullWidth
                                                    size="small"
                                                    label="Amount"
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <Typography variant="body2" color="text.secondary">₹</Typography>
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                    {...register(`list.${index}.amount`)}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    fullWidth
                                                    size="small"
                                                    type="datetime-local"
                                                    label="Date and Time"
                                                    {...register(`list.${index}.timestamp`)}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Paper>
                            </Grid>
                        ))}

                        {/* Add entry button */}
                        <Grid item xs={12}>
                            <Button
                                fullWidth
                                variant="outlined"
                                size="medium"
                                startIcon={<AddIcon />}
                                onClick={() => append({ paymentMode: "", bankName: "", utrNo: "", timestamp: "", amount: "" })}
                                sx={{
                                    borderStyle: 'dashed',
                                    color: 'warning',
                                    borderColor: 'divider',
                                    py: 1.25,
                                    '&:hover': { borderStyle: 'dashed', borderColor: 'primary.main', color: 'primary.main', bgcolor: 'primary.50' },
                                }}
                            >
                                Add Payment Entry
                            </Button>
                        </Grid>

                        <Grid item xs={12}>
                            <Divider><Typography variant="caption" color="text.disabled">Additional Info</Typography></Divider>
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                                size="small"
                                label="Remark"
                                multiline
                                rows={4}
                                placeholder="Add any notes or remarks..."
                                {...register(`remark`, {
                                    validate: (value) =>
                                        reportStage === "PARTIALLY_PAID" && !value?.trim()
                                            ? "Remark is required for Partially Paid status"
                                            : true,
                                })}
                                error={!!errors.remark}
                                helperText={errors.remark?.message}
                            />
                        </Grid>

                        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', pt: 0.5 }}>
                            <LoadingButton
                                loading={isSubmitting}
                                variant="contained"
                                size="medium"
                                type="submit"
                                sx={{ px: 5, borderRadius: 1.5 }}
                            >
                                Submit Payment
                            </LoadingButton>
                        </Grid>
                    </Grid>
                </FormProvider>
            </CardContent>
        </Card>
    )
}

export default BankDetails

